import ResourceManager from "@/components/common/ResourceManager";
import { eur, fdate, km, daysUntil, monthsBetween, fmonths } from "@/lib/format";
import { DeadlineBadge } from "@/components/common/Badges";

const vehLabel = (id, lookups) => {
  const v = (lookups.vehicles || []).find((x) => x.id === id);
  return v ? `${v.brand} ${v.model} (${v.registration})` : "—";
};
const statusFromDate = (d) => {
  if (!d) return "neutral";
  const days = daysUntil(d);
  if (days < 15) return "critical"; if (days <= 30) return "warning"; return "ok";
};
const isEnded = (r) => r.status === "Terminé" || (r.end_date && daysUntil(r.end_date) < 0);
const duration = (r) => (r.start_date && r.end_date ? fmonths(monthsBetween(r.start_date, r.end_date)) : "—");

const validate = (f) => (f.start_date && f.end_date && f.start_date >= f.end_date ? "La date de début doit être antérieure à la date de fin" : null);

const urlFilters = {
  echeance: {
    label: (v) => `Échéance < ${v} jours`,
    test: (r, v) => !isEnded(r) && r.end_date && daysUntil(r.end_date) < Number(v),
  },
};

export default function Contracts() {
  const columns = [
    { key: "vehicle_id", label: "Véhicule", render: (r, l) => vehLabel(r.vehicle_id, l) },
    { key: "type", label: "Type" },
    { key: "supplier", label: "Fournisseur" },
    { key: "contract_number", label: "N° contrat", render: (r) => <span className="font-mono text-xs">{r.contract_number}</span> },
    { key: "monthly_rent", label: "Loyer", render: (r) => eur(r.monthly_rent) },
    { key: "contractual_mileage", label: "Km contractuel", render: (r) => km(r.contractual_mileage) },
    { key: "start_date", label: "Début", render: (r) => fdate(r.start_date) },
    { key: "duration", label: "Durée", render: (r) => <span data-testid="contract-duration">{duration(r)}</span> },
    { key: "end_date", label: "Échéance", render: (r) => (isEnded(r) ? fdate(r.end_date) : <DeadlineBadge level={statusFromDate(r.end_date)}>{fdate(r.end_date)}</DeadlineBadge>) },
    { key: "status", label: "Statut", render: (r) => (isEnded(r)
      ? <span className="inline-flex rounded-full border border-gray-300 bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-700" data-testid="contract-status-ended">Terminé</span>
      : <span className="inline-flex rounded-full border border-emerald-200 bg-emerald-50 px-2.5 py-0.5 text-xs font-medium text-emerald-800" data-testid="contract-status-active">En cours</span>) },
  ];
  const fields = [
    { key: "vehicle_id", label: "Véhicule", type: "vehicle", full: true },
    { key: "type", label: "Type de contrat", type: "select", options: ["LOA", "LLD", "Achat", "Location courte durée"] },
    { key: "supplier", label: "Fournisseur" },
    { key: "start_date", label: "Date de début (facultatif)", type: "date" },
    { key: "end_date", label: "Date fin", type: "date" },
    { key: "monthly_rent", label: "Loyer mensuel (€)", type: "number" },
    { key: "contractual_mileage", label: "Km contractuel", type: "number" },
    { key: "current_mileage", label: "Km actuel", type: "number" },
    { key: "total_cost", label: "Coût total (€)", type: "number" },
    { key: "insurance_cost", label: "Coût assurance (€)", type: "number" },
  ];
  return <ResourceManager title="Contrats" subtitle="LOA, LLD, achats et locations courte durée." resource="contracts" exportCollection="contracts" columns={columns} fields={fields} lookupsNeeded={["vehicles"]} defaultForm={{ type: "LLD" }} urlFilters={urlFilters} validate={validate} />;
}
